import { render, staticRenderFns } from "./SendSmsHistoryInformation.vue?vue&type=template&id=55e1efb8&scoped=true&"
import script from "./SendSmsHistoryInformation.vue?vue&type=script&lang=js&"
export * from "./SendSmsHistoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsHistoryInformation.vue?vue&type=style&index=0&id=55e1efb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e1efb8",
  null
  
)

export default component.exports